//@flow

import { AdvisorAssets } from 'utils/ExportCommon';
import OptionList from 'models/OptionList';

export const DataStepsProcessAdvisor = [
  {
    label: 'Propietario',
    value: 'owner_step',
    step: 'propietario',
    iconDarkGray: AdvisorAssets.AdvisorOwnerDarkGray,
    iconGray: AdvisorAssets.AdvisorOwnerGray
  },
  {
    label: 'Inmueble',
    value: 'home',
    step: 'inmueble',
    iconDarkGray: AdvisorAssets.AdvisorHomeDarkGray,
    iconGray: AdvisorAssets.AdvisorHomeGray
  },
  {
    label: 'Inquilino',
    value: 'tenant',
    step: 'inquilino',
    iconDarkGray: AdvisorAssets.AdvisorTenantDarkGray,
    iconGray: AdvisorAssets.AdvisorTenantGray
  }
];

export const HomeApplicationSteps = [
  { label: 'Perfil', value: 'profile' },
  { label: 'Ingresos', value: 'income' },
  { label: 'Referencias', value: 'references' },
  { label: 'Documentos', value: 'documents' },
  { label: 'Pago', value: 'payment' },
  { label: 'Completada', value: 'complete' }
];

export const InputSettings = {
  bottomPadding: 15,
  fontSize: 14
};

export const GuarantorSteps = [
  {
    label: 'Perfil',
    value: 'profile',
    step: 'perfil',
    iconDarkGray: AdvisorAssets.GuarantorProfileDarkGray,
    iconGray: AdvisorAssets.GuarantorProfileGray
  },
  {
    label: 'Propiedad',
    value: 'home',
    step: 'propiedad',
    iconDarkGray: AdvisorAssets.GuarantorPropertyDarkGray,
    iconGray: AdvisorAssets.GuarantorPropertyGray
  },
  {
    label: 'Documentos del inmueble',
    value: 'home_documents',
    step: 'documentos_inmueble',
    iconDarkGray: AdvisorAssets.GuarantorHomeDocumentDarkGray,
    iconGray: AdvisorAssets.GuarantorHomeDocumentGray
  },
  {
    label: 'Documentos del cónyuge',
    value: 'partner_in_law_documents',
    step: 'documentos_conyugue',
    iconDarkGray: AdvisorAssets.GuarantorSpouseDocumentDarkGray,
    iconGray: AdvisorAssets.GuarantorSpouseDocumentGray
  },
  {
    label: 'Documentos co propietario',
    value: 'co_owner_documents',
    step: 'documentos_copropietario',
    iconDarkGray: AdvisorAssets.GuarantorCoOwnerDocumentDarkGray,
    iconGray: AdvisorAssets.GuarantorCoOwnerDocumentGray
  }
];

export const HomeAppSteps = [
  {
    label: 'Perfil',
    value: 'profile',
    step: 'perfil',
    iconDarkGray: AdvisorAssets.TenantProfileDarkGray,
    iconGray: AdvisorAssets.TenantProfileGray
  },
  {
    label: 'Ingresos',
    value: 'income',
    step: 'ingresos',
    iconDarkGray: AdvisorAssets.TenantIncomeDarkGray,
    iconGray: AdvisorAssets.TenantIncomeGray
  },
  {
    label: 'Referencias',
    value: 'references',
    step: 'referencias',
    iconDarkGray: AdvisorAssets.TenantReferencesDarkGray,
    iconGray: AdvisorAssets.TenantReferencesGray
  },
  {
    label: 'Documentos',
    value: 'documents',
    step: 'documentos',
    iconDarkGray: AdvisorAssets.TenantDocumentsDarkGray,
    iconGray: AdvisorAssets.TenantDocumentsGray
  },
  {
    label: 'Pago',
    value: 'payment',
    step: 'pago',
    iconDarkGray: AdvisorAssets.TenantPaymentDarkGray,
    iconGray: AdvisorAssets.TenantPaymentGray
  }
  // {label: 'Aplicación completada', value: 'complete', step: 'aplicacion-completada', iconDarkGray: AdvisorAssets.SuccessProcessDarkGray,  iconGray: AdvisorAssets.SuccessProcessDarkGray},
];

export const Gender = [
  {
    label: 'Masculino',
    value: 'male'
  },
  {
    label: 'Femenino',
    value: 'female'
  }
];

export const InsuranceOptions = [
  new OptionList('life_insurance', 'Seguro de vida'),
  new OptionList('mayor_medical_expense', 'Gastos médicos mayores'),
  new OptionList('minor_medical_expenses', 'Gastos médicos menores'),
  new OptionList('car_insurance', 'Seguro de auto')
];
